import { Company, DataConnection } from '@lendica/utils';
import { ReactNode, createContext, useContext, useState, useEffect } from 'react';
import { useDataConnectionApi } from './api';

interface DataConnectionContextInterface {
    isLoading: boolean;
    company: Company; // TODO replace with type that accounts for API 2.0 response
    connections: DataConnection[];
    refreshConnections: () => Promise<void>;
}

const defaultState: DataConnectionContextInterface = {
    isLoading: true,
    company: {} as Company,
    connections: [] as DataConnection[],
    refreshConnections: async () => {},
};

const DataConnectionDataContext = createContext<DataConnectionContextInterface>(defaultState);

export const useDataConnectionDataContext = () => {
    return useContext(DataConnectionDataContext);
};

export const DataConnectionData = ({ children }: { children: ReactNode }) => {
    const [state, setState] = useState(defaultState);
    const api = useDataConnectionApi();

    const loadConnections = async () => {
        setState(currentState => ({ ...currentState, isLoading: true }));
        try {
            const data = await api.getDataConnectionsList();
            setState(currentState => ({ ...currentState, connections: data.results }));
        } catch {
        } finally {
            setState(currentState => ({ ...currentState, isLoading: false }));
        }
    };

    useEffect(() => {
        let cancelled = false;
        (async () => {
            await loadConnections();
            if (cancelled) return;
        })();
        return () => {
            cancelled = true;
        };
    }, [api]);

    return (
        <DataConnectionDataContext.Provider
            value={{
                ...state,
                refreshConnections: loadConnections,
            }}
        >
            {children}
        </DataConnectionDataContext.Provider>
    );
};
